const CardIcon = () => (
  <svg
    width="39"
    height="30"
    viewBox="0 0 39 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M35 0H3.88889C2.85929 0.00584444 1.87353 0.417422 1.14547 1.14547C0.417422 1.87353 0.00584445 2.85929 0 3.88889V26.1111C0.00584445 27.1407 0.417422 28.1264 1.14547 28.8544C1.87353 29.5827 2.85929 29.9942 3.88889 30H35C36.0296 29.9942 37.0153 29.5827 37.7433 28.8544C38.4716 28.1264 38.8831 27.1407 38.8889 26.1111V3.88889C38.8831 2.85929 38.4716 1.87353 37.7433 1.14547C37.0153 0.417422 36.0296 0.00584444 35 0ZM3.88889 3.33333H35C35.1473 3.33333 35.2887 3.39187 35.3929 3.49604C35.4971 3.60024 35.5556 3.74156 35.5556 3.88889V8.88889H3.33333V3.88889C3.33333 3.74156 3.39187 3.60024 3.49604 3.49604C3.60024 3.39187 3.74156 3.33333 3.88889 3.33333ZM35 26.6667H3.88889C3.74156 26.6667 3.60024 26.6082 3.49604 26.504C3.39187 26.3998 3.33333 26.2584 3.33333 26.1111V12.2222H35.5556V26.1111C35.5556 26.2584 35.4971 26.3998 35.3929 26.504C35.2887 26.6082 35.1473 26.6667 35 26.6667Z"
      fill="#000000"
    />
  </svg>
);

export default CardIcon;
